dmx.Component('f7-range-dual', {

    extends: 'f7-range',

    initialData: {
        start: null,
        end: null
    },

    attributes: {
        'value-start': {
            type: Number,
            default: null
        },

        'value-end': {
            type: Number,
            default: null
        },
    },

    methods: {
        setValues: function(start, end) {
            if (!this.component) return;
            this.component.setValue([start, end]);
        },
    },

    init: function(node) {
        var self = this;

        this.component = Framework7.instance.range.create({
            el: node,
            dual: true,
            value: [this.props['value-start'], this.props['value-end']],
            min: this.props.min,
            max: this.props.max,
            step: this.props.step,
            label: this.props.label,
            draggableBar: !this.props['no-draggable-bar'],
            vertical: this.props.vertical,
            verticalReversed: this.props['vertical-reversed'],
            scale: this.props.scale,
            scaleSteps: this.props['scale-steps'],
            scaleSubSteps: this.props['scale-sub-steps'],
        });

        this.component.on('change', function(range, value) {
            self.set('start', value[0]);
            self.set('end', value[1]);
            self.dispatchEvent('change');
        });

        this.component.on('changed', function() {
            self.dispatchEvent('changed');
        });

        this.set('start', this.component.value[0]);
        this.set('end', this.component.value[1]);
    },

    update: function(props) {
        if (props['value-start'] != this.props['value-start'] || props['value-end'] != this.props['value-end']) {
            this.component.setValue([this.props['value-start'], this.props['value-end']]);
        }
    }

});